<template>
  <div class="normal-toggle-chart">
    <basic-container>
      <Header title="数据统计" :hasPicker="true" ref="Header"  @refreshNoheader="getTableNoData"/>

      <div class="header__date" flex="cross:center">
        <div
          v-for="(item,index) in tooggleDate"
          :key="index"
          class="header__date-row"
          flex="cross:center"
          :class="tooggleDateIndex === index?'header__date-row--active':''"
          @click="onHandleToggleDate(item,index)"
        >{{item}}</div>
      </div>

      <ve-line
        :data="chartData"
        :toolbox="toolbox"
        :settings="chartSettings"
        :extend="percentExtend"
      ></ve-line>
    </basic-container>
  </div>
</template>

<script>
import "echarts/lib/component/toolbox";
import VeLine from "v-charts/lib/line";
import VeBar from "v-charts/lib/bar";
import BasicContainer from "@vue-materials/basic-container";
import Header from "../HeaderNormal";
import util from '@/libs/util.js';
import * as agentService from "@/api/sys/agent";
export default {
  components: { BasicContainer, VeLine, VeBar, 'Header':Header },
  name: "NormalToggleChart",
  data() {
    this.chartSettings = {
      // axisSite: { right: ["下单率"] },
      // yAxisType: ["KMB", "percent"],
      // yAxisName: ["数值", "比率"]
    };

    return {
      tooggleDateIndex: 0,
      tooggleDate: ["我的佣金", "交易金额", "交易笔数", "退款金额", "退款笔数"],
        activetitle: ['日期'],
      toolbox: {
        feature: {
          magicType: { type: ["line", "bar"] },
          saveAsImage: {
            name: "v-chart-temp"
          }
        }
      },
      percentExtend: {
        series: {
          label: {
            show: false,
            formatter: function(params) {
              if (params.seriesIndex == 2) {
                str = params.data[1] * 100 + "%";
                return str;
              }
            }
          }
        },
        legend: {
          bottom: 20
        }
      },
      chartData: {
        columns: ["日期","我的佣金"],
        rows: [
        ]
      }
    };
  },
    mounted() {
        this.getTableData();
    },
  methods: {
      getTableNoData(){

          if(this.tooggleDateIndex==0){
              this.getTableData();
          }else if(this.tooggleDateIndex==1){
              this.getTableDatajyje();
          }else if(this.tooggleDateIndex==2){
              this.getTableDatajybs();
          }else if(this.tooggleDateIndex==3){
              this.getTableDatatkje();
          }else if(this.tooggleDateIndex==4){
              this.getTableDatatkbs();
          }

      },
      dateConversion(value){
          var d = new Date(value);
          //  var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
          var date = d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
          console.info("===========date========="+date);
          return date;
      },
      getTableData(){
          var formData4 = new FormData() // 声明一个FormData对象
          formData4.append("agentid",util.cookies.get('agentid'));
          formData4.append("type","0");
          formData4.append("dl_type",util.cookies.get('dl_type'));
          formData4.append("start_time", this.dateConversion(this.$refs.Header.pickerValue[0]));
          formData4.append("end_time", this.dateConversion(this.$refs.Header.pickerValue[1]));
          formData4.append("dl_type",util.cookies.get('dl_type'));
          formData4.append("xt_id",util.cookies.get('xt_id'));
          //let countlistTitle=["日期", "微信", "支付宝", "银行卡", "现金"];
          let countlistArray=[];
          this.activetitle=["日期"];
          this.activetitle.push("我的佣金");
          agentService.getStatisticsHomesjtj(formData4).then(data => {
              if(data!=null && data!=""){
                  //循环遍历,将穿回来的list转换为chart需要的键值对形式

                  for (let index = 0; index < data.length; index++) {
                      let countlistmap={};
                      if (data[index].serve_agent_amt !== null) {
                          countlistmap['我的佣金'] =  data[index].serve_agent_amt;
                          /**countlistmap['微信'] = data[index].order_amount;
                          countlistmap['支付宝'] = data[index].order_num;
                          countlistmap['银行卡'] = data[index].order_num;
                          countlistmap['会员卡'] = data[index].order_num;
                          countlistmap['未知'] = data[index].order_num;**/
                          countlistmap['日期'] = data[index].order_time;
                          countlistArray.push(countlistmap);
                      }
                  }
                  //将键值对形式加到array数组里
                  //将行和列分别赋值给chartdata的行和列
                  console.info("countlistArray==="+countlistArray);
                  this.chartData.columns=this.activetitle;
                  this.chartData.rows=countlistArray;



              }else{
                  this.chartData.columns=this.activetitle;
                  this.chartData.rows=countlistArray;
              }
          });

      },
    getTableDatajyje(){
        var formData4 = new FormData() // 声明一个FormData对象
        formData4.append("agentid",util.cookies.get('agentid'));
        formData4.append("type","1");
        formData4.append("dl_type",util.cookies.get('dl_type'));
        formData4.append("start_time", this.dateConversion(this.$refs.Header.pickerValue[0]));
        formData4.append("end_time", this.dateConversion(this.$refs.Header.pickerValue[1]));
        formData4.append("xt_id",util.cookies.get('xt_id'));
        this.activetitle=["日期"];
        this.activetitle.push("微信");
        this.activetitle.push("支付宝");
        this.activetitle.push("银行卡");
        this.activetitle.push("会员");
        this.activetitle.push("未知");
        // let countlistTitle=["日期", "我的佣金"];
        let countlistArray=[];
        agentService.getStatisticsHomesjtj(formData4).then(data => {
            if(data!=null && data!=""){
                //循环遍历,将穿回来的list转换为chart需要的键值对形式

                for (let index = 0; index < data.length; index++) {
                    let countlistmap={};
                    if (data[index].serve_agent_amt !== null) {
                        //countlistmap['我的佣金'] = data[index].serve_agent_amt;
                        countlistmap['微信'] = data[index].wx_num_amount;
                        countlistmap['支付宝'] = data[index].zfb_num_amount;
                        countlistmap['银行卡'] = data[index].yhk_num_amount;
                        countlistmap['会员卡'] = data[index].fyk_num_amount;
                        countlistmap['未知'] = data[index].wz_num_amount;
                        countlistmap['日期'] = data[index].order_time;
                        countlistArray.push(countlistmap);
                    }
                }
                //将键值对形式加到array数组里
                //将行和列分别赋值给chartdata的行和列
                this.chartData.columns=this.activetitle;
                this.chartData.rows=countlistArray;



            }else{
                this.chartData.columns=this.activetitle;
                this.chartData.rows=countlistArray;
            }
        });

    },
      getTableDatajybs(){
          var formData4 = new FormData() // 声明一个FormData对象
          formData4.append("agentid",util.cookies.get('agentid'));
          formData4.append("type","2");
          formData4.append("dl_type",util.cookies.get('dl_type'));
          formData4.append("start_time", this.dateConversion(this.$refs.Header.pickerValue[0]));
          formData4.append("end_time", this.dateConversion(this.$refs.Header.pickerValue[1]));
          formData4.append("xt_id",util.cookies.get('xt_id'));
          this.activetitle=["日期"];
          this.activetitle.push("微信");
          this.activetitle.push("支付宝");
          this.activetitle.push("银行卡");
          this.activetitle.push("会员");
          this.activetitle.push("未知");
          // let countlistTitle=["日期", "我的佣金"];
          let countlistArray=[];
          agentService.getStatisticsHomesjtj(formData4).then(data => {
              if(data!=null && data!=""){
                  //循环遍历,将穿回来的list转换为chart需要的键值对形式

                  for (let index = 0; index < data.length; index++) {
                      let countlistmap={};
                      if (data[index].serve_agent_amt !== null) {
                          //countlistmap['我的佣金'] = data[index].serve_agent_amt;
                          countlistmap['微信'] = data[index].wx_num;
                          countlistmap['支付宝'] = data[index].zfb_num;
                          countlistmap['银行卡'] = data[index].yhk_num;
                          countlistmap['会员卡'] = data[index].fyk_num;
                          countlistmap['未知'] = data[index].wz_num;
                          countlistmap['日期'] = data[index].order_time;
                          countlistArray.push(countlistmap);
                      }
                  }
                  //将键值对形式加到array数组里
                  //将行和列分别赋值给chartdata的行和列
                  this.chartData.columns=this.activetitle;
                  this.chartData.rows=countlistArray;



              }else{
                  this.chartData.columns=this.activetitle;
                  this.chartData.rows=countlistArray;
              }
          });

      }
      ,
      getTableDatatkje(){
          var formData4 = new FormData() // 声明一个FormData对象
          formData4.append("agentid",util.cookies.get('agentid'));
          formData4.append("type","3");
          formData4.append("dl_type",util.cookies.get('dl_type'));
          formData4.append("start_time", this.dateConversion(this.$refs.Header.pickerValue[0]));
          formData4.append("end_time", this.dateConversion(this.$refs.Header.pickerValue[1]));
          formData4.append("xt_id",util.cookies.get('xt_id'));
          this.activetitle=["日期"];
          this.activetitle.push("微信");
          this.activetitle.push("支付宝");
          this.activetitle.push("银行卡");
          this.activetitle.push("会员");
          this.activetitle.push("未知");
          // let countlistTitle=["日期", "我的佣金"];
          let countlistArray=[];
          agentService.getStatisticsHomesjtj(formData4).then(data => {
              if(data!=null && data!=""){
                  //循环遍历,将穿回来的list转换为chart需要的键值对形式

                  for (let index = 0; index < data.length; index++) {
                      let countlistmap={};
                      if (data[index].serve_agent_amt !== null) {
                          //countlistmap['我的佣金'] = data[index].serve_agent_amt;
                          countlistmap['微信'] = data[index].wx_num_amount;
                          countlistmap['支付宝'] = data[index].zfb_num_amount;
                          countlistmap['银行卡'] = data[index].yhk_num_amount;
                          countlistmap['会员卡'] = data[index].fyk_num_amount;
                          countlistmap['未知'] = data[index].wz_num_amount;
                          countlistmap['日期'] = data[index].order_time;
                          countlistArray.push(countlistmap);
                      }
                  }
                  //将键值对形式加到array数组里
                  //将行和列分别赋值给chartdata的行和列
                  this.chartData.columns=this.activetitle;
                  this.chartData.rows=countlistArray;



              }else{
                  this.chartData.columns=this.activetitle;
                  this.chartData.rows=countlistArray;
              }
          });

      },
      getTableDatatkbs(){
          var formData4 = new FormData() // 声明一个FormData对象
          formData4.append("agentid",util.cookies.get('agentid'));
          formData4.append("type","4");
          formData4.append("start_time", this.dateConversion(this.$refs.Header.pickerValue[0]));
          formData4.append("end_time", this.dateConversion(this.$refs.Header.pickerValue[1]));
          formData4.append("dl_type",util.cookies.get('dl_type'));
          formData4.append("xt_id",util.cookies.get('xt_id'));
          this.activetitle=["日期"];
          this.activetitle.push("微信");
          this.activetitle.push("支付宝");
          this.activetitle.push("银行卡");
          this.activetitle.push("会员");
          this.activetitle.push("未知");
          // let countlistTitle=["日期", "我的佣金"];
          let countlistArray=[];
          agentService.getStatisticsHomesjtj(formData4).then(data => {
              if(data!=null && data!=""){
                  //循环遍历,将穿回来的list转换为chart需要的键值对形式

                  for (let index = 0; index < data.length; index++) {
                      let countlistmap={};
                      if (data[index].serve_agent_amt !== null) {
                          //countlistmap['我的佣金'] = data[index].serve_agent_amt;
                          countlistmap['微信'] = data[index].wx_num;
                          countlistmap['支付宝'] = data[index].zfb_num;
                          countlistmap['银行卡'] = data[index].yhk_num;
                          countlistmap['会员卡'] = data[index].fyk_num;
                          countlistmap['未知'] = data[index].wz_num;
                          countlistmap['日期'] = data[index].order_time;
                          countlistArray.push(countlistmap);
                      }
                  }
                  //将键值对形式加到array数组里
                  //将行和列分别赋值给chartdata的行和列
                  this.chartData.columns=this.activetitle;
                  this.chartData.rows=countlistArray;



              }else{
                  this.chartData.columns=this.activetitle;
                  this.chartData.rows=countlistArray;
              }
          });

      },
    onHandleToggleDate(item, index) {
      this.tooggleDateIndex = index;
      if(index==0){
          this.getTableData();
      }else if(index==1){
          this.getTableDatajyje();
      }else if(index==2){
          this.getTableDatajybs();
      }else if(index==3){
          this.getTableDatatkje();
      }else if(index==4){
          this.getTableDatatkbs();
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  &__date {
    display: inline-block;
    height: 30px;
    margin-top: 20px;
    border-radius: 4px;
    border: 1px solid #dcdfe6;
  }
  &__date-row {
    padding: 0 0.2rem;
    height: 30px;
    float: left;
    font-size: 12px;
  }
  &__date-row--active {
    background-color: #409eff !important;
    color: #fff;
  }
  &__date-row:not(:last-child) {
    border-right: 1px solid #dcdfe6;
  }
}
</style>
